import { Component, EventEmitter, Input, Output } from '@angular/core';

import { fillSkeletonData } from 'src/app/@shared/app-helper';

import { UserModel } from 'src/app/user/@shared/user.model';

@Component({
  selector: 'user-preview',
  standalone: false,
  styleUrls: ['./user-preview.component.scss'],
  templateUrl: './user-preview.component.html',
})
export class UserPreviewComponent {
  @Output() public openDetail: EventEmitter<UserModel> = new EventEmitter<UserModel>();

  public showSkeleton: boolean = true;

  // fill item with skeleton data
  // always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<UserModel> = {
    title: fillSkeletonData('title'),
  };

  @Input()
  public get item(): UserModel {
    return this._item as UserModel;
  }

  public set item(item: UserModel) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<UserModel>;
    this.showSkeleton = false;
  }
}
